export default __webpack_public_path__ + "static/shutdown-banner-mobile-2dc40f4381ce3567299078dfd1b91cb6.png";